import { useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";

export default function ExpenseToolbar({
  excelRef,
  onAdd,
  onExportCsv,
  onExportJson,
  onImportCsv,
  onImportFile,
  pdfRef,
  t = {}
}) {
  const importInputRef = useRef(null);
  const handleImport = onImportFile || onImportCsv;

  return (
    <section className="toolbar-panel">
      <div>
        <p className="eyebrow">{t.expenses || "Expenses"}</p>
        <h2>{t.transactions || "Transactions"}</h2>
      </div>
      <div className="toolbar-actions">
        <input
          ref={importInputRef}
          accept=".csv,.json,.xlsx,.xls,text/csv,application/json"
          className="hidden-input"
          type="file"
          onChange={(event) => {
            const file = event.target.files?.[0];
            if (file) handleImport(file);
            event.target.value = "";
          }}
        />
        <Button fillMode="outline" icon="upload" onClick={() => importInputRef.current?.click()}>
          {t.import || "Import"}
        </Button>
        <Button fillMode="outline" icon="file-excel" onClick={() => excelRef.current?.save()}>
          {t.excel || "Excel"}
        </Button>
        <Button fillMode="outline" icon="file-pdf" onClick={() => pdfRef.current?.save()}>
          {t.pdf || "PDF"}
        </Button>
        <Button fillMode="outline" icon="file-csv" onClick={onExportCsv}>
          {t.csv || "CSV"}
        </Button>
        <Button fillMode="outline" icon="file-data" onClick={onExportJson}>
          {t.json || "JSON"}
        </Button>
        <Button themeColor="primary" icon="plus" onClick={onAdd}>
          {t.addExpense || "Add expense"}
        </Button>
      </div>
    </section>
  );
}
